export default "__VITE_ASSET__CWs9TP0Y__"